import { render } from "./BreadcrumbOt.vue?vue&type=template&id=038e7685&scoped=true"
import script from "./BreadcrumbOt.vue?vue&type=script&lang=js"
export * from "./BreadcrumbOt.vue?vue&type=script&lang=js"

import "./BreadcrumbOt.vue?vue&type=style&index=0&id=038e7685&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038e7685"]])

export default __exports__